import type { ReactNode } from "react";

/**
 * An empty screen is an invitation to act: say what is missing and offer the
 * next step. A dashed card, so it reads as "nothing here" on the page and
 * inside a card alike.
 */
export function EmptyState({
	title,
	body,
	action,
	icon,
	className = "",
}: {
	title: string;
	body?: ReactNode;
	action?: ReactNode;
	icon?: ReactNode;
	className?: string;
}) {
	return (
		<div
			className={`flex flex-col items-start gap-[0.625rem] rounded-card border border-rule border-dashed bg-sheet/60 px-[1.25rem] py-[1.25rem] ${className}`}
		>
			{icon && <div className="text-muted">{icon}</div>}
			<h2 className="font-black text-[1.125rem] text-ink leading-tight">{title}</h2>
			{body && <div className="max-w-[60ch] text-[0.9375rem] text-muted leading-relaxed">{body}</div>}
			{action && <div className="mt-[0.25rem]">{action}</div>}
		</div>
	);
}
